import { FormSection, RenderEditOptions } from "components/MainSectionTemplate/types";
import { YesNoRadioGroupForInPageEditing, YesNoText } from "components/ValidatedFields/YesNoRadioGroup";
import React from "react";
import { getUpdateInstruction, WebformFormState } from "./model";
import { AtLeastOneTranslationValueInput, TranslationValueReadonly } from "./TranslationValueInnerForm";

export const additionalInformationSection = (
  webformFormState: WebformFormState,
): FormSection => ({
  key: "additionalInformation",
  title: RESX.Company.AdditionalInformation,
  type: "collapsable",
  fields: [{
    key: "displayEventNote",
    label: RESX.GeneralLabels.Display,
    sublabel: RESX.Webform.FreeTextField,
    render: () => <YesNoText value={webformFormState.displayEventNote} />,
    inPageEdit: {
      render: ({ value, onChange }: RenderEditOptions<boolean>) => <YesNoRadioGroupForInPageEditing
        value={value}
        onChange={v => onChange(v, true)}
      />,
      fullWidth: true,
      type: "custom",
      initialValue: webformFormState.displayEventNote,
      submitChange: (displayEventNote: boolean) => window.CoreApi.WebformConfiguration.UpdateDetails({
        ...getUpdateInstruction(webformFormState),
        displayEventNote,
      }),
    }
  }, {
    key: "eventNoteLabel",
    label: RESX.GeneralLabels.Label,
    hidden: !webformFormState.displayEventNote,
    isEmpty: webformFormState.eventNoteLabel.length === 0,
    render: () => <TranslationValueReadonly values={webformFormState.eventNoteLabel} />,
    inPageEdit: {
      render: ({ value, onChange, submit, isSaving }: RenderEditOptions<server.dto.TranslationValue[]>) => <AtLeastOneTranslationValueInput
        validatorKey="eventNoteLabel"
        submit={submit}
        onChange={onChange}
        values={value}
        isSaving={isSaving}
      />,
      fullWidth: true,
      type: "custom",
      initialValue: webformFormState.eventNoteLabel,
      submitChange: (eventNoteLabel: server.dto.TranslationValue[]) => window.CoreApi.WebformConfiguration.UpdateDetails({
        ...getUpdateInstruction(webformFormState),
        eventNoteLabel,
      }),
    }
  }]
});